// extracted by mini-css-extract-plugin
export default {"card":"ErrorAlert_card__cRbte","iconLeft":"ErrorAlert_iconLeft__hSiPJ","iconRight":"ErrorAlert_iconRight__aogtf"};